import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { localeStrings as strings } from 'applicationConfig';
import Button from 'common/components/Button';

@observer
class ReportingGridRow extends Component {
  state = {
    selectedOption: '',
  };

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };

  handleClick = () => {
    const data = {
      id: this.props.data.id,
      selected: this.state.selectedOption.value
    };
    this.props.onClick(data);
  };

  render() {
    const { selectedOption } = this.state;
    const { name, options } = this.props.data;
    return (
      <div className="execution-reporting-grid-row field-group">
        <div className="field-group-label">{name}</div>
        <div className="field-group-value">
          <Select
            clearable={true}
            className="tpi-select"
            value={selectedOption}
            onChange={this.handleChange}
            options={options}
            isLoading={false}
            disabled={false}
          />
        </div>
        <div className="actions link">
          <Button
            className="btn btn-primary"
            onClick={this.handleClick}
            disabled={!selectedOption}>
            <span className="button-caption">{strings.executionReporting.submit}</span>
          </Button>
        </div>
      </div>
    );
  }
}

export default ReportingGridRow;



// WEBPACK FOOTER //
// ./src/containers/Reporting/ReportingGridRow.jsx